import React from 'react';
import TitreSection from './TitreSection';
import Formulaire from './Formulaire';
import Bande from './Bande';
import Carte from './Carte';
import { ENTREPRISE } from '../data/site';

// Bloc contact complet : formulaire a gauche, carte et coordonnees a droite.
// Utilise en bas de la page d'accueil et sur la page contact.
export default function SectionContact({
  avant = 'Parlez-nous de votre ',
  mot = 'chantier',
  apres = '',
  intro = "Quelques informations suffisent pour qu'on vous réponde précisément. Et si c'est urgent, le téléphone reste le plus rapide.",
  id = 'contact',
}) {
  return (
    <section id={id} className="bg-trame">
      <Bande hauteur={5} />
      <div className="conteneur py-14 sm:py-18">
        <TitreSection avant={avant} mot={mot} apres={apres} />
        <p className="mt-4 max-w-2xl text-nuit/75">{intro}</p>

        <div className="mt-9 grid lg:grid-cols-[1fr_0.62fr] gap-8">
          <Formulaire />

          <aside className="space-y-5">
            <div className="carte overflow-hidden">
              <Carte hauteur={260} />

              <div className="p-6 border-t border-nuit/10">
                <h3 className="font-display uppercase text-[21px] text-nuit">Nos bureaux</h3>
                <address className="not-italic mt-2.5 text-nuit/85">
                  {ENTREPRISE.adresse}
                  <br />
                  {ENTREPRISE.codePostal} {ENTREPRISE.ville}
                </address>
                <p className="mt-3 text-nuit/85">{ENTREPRISE.horaires}</p>
                <a
                  className="btn-ligne mt-5 w-full"
                  href="https://www.google.com/maps/search/?api=1&query=2+boulevard+Carnot+94140+Alfortville"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ouvrir dans Google Maps
                </a>
              </div>
            </div>

            <div className="carte p-6 border-t-4 border-t-jaune">
              <h3 className="font-display uppercase text-[21px] text-nuit">Nous joindre</h3>
              <a
                href={ENTREPRISE.telephoneLien}
                className="block font-display text-[30px] text-nuit mt-2.5 hover:text-orange transition-colors"
              >
                {ENTREPRISE.telephone}
              </a>
              <a
                href={ENTREPRISE.emailLien}
                className="block mt-2 text-bleu font-semibold break-all hover:text-orange transition-colors"
              >
                {ENTREPRISE.email}
              </a>
              <p className="mt-3 text-beton text-[15px]">
                Réponse en quelques heures ouvrées. Livraison sur votre chantier sous 24 à 48 h.
              </p>
            </div>

            <div className="carte p-6 border-l-4 border-l-bleu">
              <h3 className="font-cond uppercase font-bold tracking-[0.05em] text-[17px] text-nuit">
                Ce qui accélère votre devis
              </h3>
              <ul className="mt-3 space-y-2 text-[15.5px] text-nuit/80">
                {[
                  'La commune du chantier',
                  'Vos dates de location',
                  'La largeur de votre accès',
                  'Avec ou sans chauffeur',
                ].map((x) => (
                  <li key={x} className="flex gap-2.5">
                    <span className="mt-2 shrink-0 w-2 h-2 bg-jaune" aria-hidden="true" />
                    {x}
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
